"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MavenCdmsJwtAuthTokenIssuer = exports.MavenService = exports.Actant = exports.RequestToken = exports.AuthToken = exports.AuthTokenDestroyedReason = exports.RequestTokenType = void 0;
var RequestTokenType;
(function (RequestTokenType) {
    RequestTokenType["DeleteAffiliation"] = "DELETE-AFFILIATION";
    RequestTokenType["DeleteUser"] = "DELETE-USER";
    RequestTokenType["RestoreUser"] = "RESTORE-USER";
    RequestTokenType["DeleteRole"] = "DELETE-ROLE";
    RequestTokenType["EsignCrf"] = "ESIGN-CRF";
    RequestTokenType["StudyLock"] = "STUDY-LOCK";
    RequestTokenType["StudyUnlock"] = "STUDY-UNLOCK";
    RequestTokenType["StudyClose"] = "STUDY-CLOSE";
    RequestTokenType["StudyReopen"] = "STUDY-REOPEN";
    RequestTokenType["StudyUserDelete"] = "STUDY-USER-DELETE";
    RequestTokenType["StudyUserRestore"] = "STUDY-USER-RESTORE";
    RequestTokenType["StudySubjectInit"] = "STUDY-SUBJECT-INIT";
    RequestTokenType["StudySubjectVisitInit"] = "STUDY-SUBJECT-VISIT-INIT";
    RequestTokenType["StudySubjectCrfInit"] = "STUDY-SUBJECT-CRF-INIT";
    RequestTokenType["StudySubjectCrfRefresh"] = "STUDY-SUBJECT-CRF-REFRESH";
    RequestTokenType["StudySubjectTriggerInvokeAllExplicitly"] = "STUDY-SUBJECT-TRIGGER-INVOKE-ALL-EXPLICITLY";
    RequestTokenType["StudySubjectUnblindRequest"] = "STUDY_SUBJECT-UNBLIND-REQUEST";
    RequestTokenType["StudySubjectUnblindApprove"] = "STUDY-SUBJECT-UNBLIND-APPROVE";
    RequestTokenType["StudySubjectUnblindForce"] = "STUDY-SUBJECT-UNBLIND-FORCE";
    RequestTokenType["StudySubjectUnblindForceUnderConds"] = "STUDY-SUBJECT-UNBLIND-FORCE-UNDER-CONDITIONS";
    RequestTokenType["StudySubjectCaptureData"] = "STUDY-SUBJECT-CAPTURE-DATA";
    RequestTokenType["StudyReportSubmit"] = "STUDY-REPORT-SUBMIT";
    RequestTokenType["StudyUatOpenSequence"] = "STUDY-UAT-OPEN-SEQUENCE";
    RequestTokenType["StudyUatCloseSequence"] = "STUDY-UAT-CLOSE-SEQUENCE";
    RequestTokenType["RandomizationInitialize"] = "RANDOMIZATION-INITIALIZE";
    RequestTokenType["RandomizationPause"] = "RANDOMIZATION-PAUSE";
    RequestTokenType["RandomizationResume"] = "RANDOMIZATION-RESUME";
    RequestTokenType["StudyIpDeliveryRequest"] = "STUDY-IP-DELIVERY-REQUEST";
    RequestTokenType["StudyIpDeliveryCancel"] = "STUDY-IP-DELIVERY-CANCEL";
    RequestTokenType["StudyIpDeliveryApprove"] = "STUDY-IP-DELIVERY-APPROVE";
    RequestTokenType["StudyIpDeliveryStart"] = "STUDY-IP-DELIVERY-START";
    RequestTokenType["StudyIpDeliveryConfirm"] = "STUDY-IP-DELIVERY-CONFIRM";
    RequestTokenType["StudyIpErrorConfirm"] = "STUDY-IP-ERROR-CONFIRM";
    RequestTokenType["StudyIpStatusChange"] = "STUDY-IP-STATUS-CHANGE";
    RequestTokenType["StudyIpReturnRequest"] = "STUDY-IP-RETURN-REQUEST";
    RequestTokenType["StudyIpReturnCancel"] = "STUDY-IP-RETURN-CANCEL";
    RequestTokenType["StudyIpReturnConfirm"] = "STUDY-IP-RETURN-CONFIRM";
    RequestTokenType["StudyIpCodeInitialize"] = "STUDY-IP-CODE-INITIALIZE";
    RequestTokenType["StudySiteDelete"] = "STUDY-SITE-DELETE";
})(RequestTokenType = exports.RequestTokenType || (exports.RequestTokenType = {}));
var AuthTokenDestroyedReason;
(function (AuthTokenDestroyedReason) {
    AuthTokenDestroyedReason["Expired"] = "EXPIRED";
    AuthTokenDestroyedReason["SignOut"] = "SIGN_OUT";
    AuthTokenDestroyedReason["NewToken"] = "NEW_TOKEN";
    AuthTokenDestroyedReason["EsignFail"] = "ESIGN_FAIL";
})(AuthTokenDestroyedReason = exports.AuthTokenDestroyedReason || (exports.AuthTokenDestroyedReason = {}));
/** @deprecated Maven REST에 정의된 타입을 참조하세요. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class AuthToken {
}
exports.AuthToken = AuthToken;
class RequestToken {
}
exports.RequestToken = RequestToken;
class Actant {
}
exports.Actant = Actant;
var MavenService;
(function (MavenService) {
    MavenService["MavenClinicalCloud"] = "MAVEN-CLINICAL-CLOUD";
    MavenService["MavenAuth"] = "MAVEN-AUTH";
    //
    MavenService["MavenCDMS"] = "MAVEN-CDMS";
    MavenService["MavenBuilder"] = "MAVEN-BUILDER";
    MavenService["MavenECoa"] = "MAVEN-ECOA";
    MavenService["MavenDocs"] = "MAVEN-DOCS";
    MavenService["MavenSafety"] = "MAVEN-SAFETY";
    MavenService["MavenValidator"] = "MAVEN-VALIDATOR";
    MavenService["MavenEConsent"] = "MAVEN-ECONSENT";
    //
    MavenService["MavenSign"] = "MAVEN-SIGN";
    MavenService["MavenTMF"] = "MAVEN-TMF";
    //
    MavenService["MavenAdmin"] = "MAVEN-ADMIN";
    //
    MavenService["MavenEdcExternal"] = "MAVEN-EDC-EXTERNAL";
    //
    MavenService["MavenVDR"] = "MAVEN-VDR";
    MavenService["MavenConverter"] = "MAVEN-CONVERTER";
})(MavenService = exports.MavenService || (exports.MavenService = {}));
var MavenCdmsJwtAuthTokenIssuer;
(function (MavenCdmsJwtAuthTokenIssuer) {
    MavenCdmsJwtAuthTokenIssuer["Auth"] = "cream:auth";
    MavenCdmsJwtAuthTokenIssuer["EdcExternal"] = "cream:auth:edc-external";
})(MavenCdmsJwtAuthTokenIssuer = exports.MavenCdmsJwtAuthTokenIssuer || (exports.MavenCdmsJwtAuthTokenIssuer = {}));
//# sourceMappingURL=auth.js.map